import clickstreamClient from '@mm-frontend/clickstream-client-js';
import { IEventsMap } from './models';

export const clickStreamClient = new clickstreamClient<IEventsMap>();
